import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const InfoButtonContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

export const InfoIcon = styled.div`
  color: ${COLOR_OPTIONS.NEUTRAL_90};
  font-size: 16px;
  transition: color 0.2s;

  .anticon {
    display: flex;
  }
`;

export const InfoText = styled.div`
  color: ${COLOR_OPTIONS.NEUTRAL_90};
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  transition: color 0.2s;
`;
